import { useContext } from 'react'
import { Link } from 'react-router-dom'
import AppMenu from './AppMenu'
import { LayoutContext } from './context/layoutcontext'
import { MenuProvider } from './context/menucontext'
import { getBrand } from '../../utils/tenant'


const AppSidebar = () => {
    const { setLayoutState } = useContext(LayoutContext)
    const anchor = () => {
        setLayoutState((prevLayoutState) => ({ ...prevLayoutState, anchored: !prevLayoutState.anchored }))
    }
    const isProd = process.env.REACT_APP_NODE_ENV === 'prod'
    const brand = getBrand()

    const textStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '40px',
        lineHeight: '45px',
        color: 'blue',
    }

    const logoTextStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '20px',
        lineHeight: '25px',
        fontWeight: 700,
        color: '#1a1a1a',
    }

    return (
        <>
            <div className="sidebar-header pt-3 mb-2">
                <Link to="/customer/sales/sales-list" className="app-logo" style={{ height: '25px', display: 'flex', alignItems: 'center' }}>
                    {isProd ? (
                        brand.logoImg ? (
                            <img
                                src={brand.logoImg}
                                alt="Logo"
                                style={{ width: '150px', objectFit: 'cover', objectPosition: 'center', height: '25px' }}
                            />
                        ) : (
                            <span style={logoTextStyle}>{brand.logoText}</span>
                        )
                    ) : (
                        <span style={textStyle}> {process.env.REACT_APP_NODE_ENV} </span>
                    )}
                </Link>
                <button className="layout-sidebar-anchor p-link z-2 mb-2" type="button" onClick={anchor}></button>
            </div>
            <div className="layout-menu-container">
                <MenuProvider>
                    <AppMenu />
                </MenuProvider>
            </div>
        </>
    )
}

export default AppSidebar
